import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-mid-page-white-item.component.scss';
var BannerMidPageWhiteItem = /** @class */ (function (_super) {
    tslib_1.__extends(BannerMidPageWhiteItem, _super);
    function BannerMidPageWhiteItem(element) {
        return _super.call(this, element) || this;
    }
    BannerMidPageWhiteItem.prototype.init = function () { };
    BannerMidPageWhiteItem.prototype.bindEvents = function () { };
    return BannerMidPageWhiteItem;
}(Base));
export { BannerMidPageWhiteItem };



//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-white-item/banner-mid-page-white-item.component.ts
// module id = 143
// module chunks = 0